import { SVGProps } from 'react';

interface ListOlProps extends SVGProps<SVGSVGElement> {
  size?: number;
}

/**
 * Ordered list icon (list with numbers).
 * TODO: Move to @raydiant/raydial when ready.
 */
const ListOl = ({ size = 12, ...props }: ListOlProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 12 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0.5625 0H1.125H1.6875H2.25V0.5625V3.375H2.4375H3V4.5H2.4375H2.25H1.125H0.9375H0.375V3.375H0.9375H1.125V1.125H0.5625V0ZM0 7.5C0 6.67969 0.65625 6 1.5 6H1.89844C2.69531 6 3.375 6.67969 3.375 7.47656C3.375 7.89844 3.1875 8.29688 2.88281 8.57812L1.99219 9.375H2.8125H3.375V10.5H2.8125H0.5625H0V9.9375V9.67969L0.164062 9.51562L2.13281 7.73438C2.20312 7.66406 2.22656 7.57031 2.22656 7.47656C2.22656 7.28906 2.08594 7.125 1.89844 7.125H1.5C1.28906 7.125 1.125 7.3125 1.125 7.5H0ZM5.0625 0.75H11.0625H11.8125V2.25H11.0625H5.0625H4.3125V0.75H5.0625ZM5.0625 4.5H11.0625H11.8125V6H11.0625H5.0625H4.3125V4.5H5.0625ZM5.0625 8.25H11.0625H11.8125V9.75H11.0625H5.0625H4.3125V8.25H5.0625Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default ListOl;
